import { ReactNode } from 'react';
import { useLocalization } from '../../../context/Localization/localization';
import { useNavigate } from 'react-router-dom';
import css from './AccessibilityButton.module.scss';
import classNames from 'classnames';
import { AppRoutePaths } from '../../../helpers/Routes';
import { BaseButtonBase } from '../BaseButtonBase/BaseButtonBase';
import { AccessibilityButtonProps } from './AccessibilityButton.types';
import { GMSizedIcon } from '../../Icon';
import { LocalizationType } from '../../../context/Localization/localization.types';

/**
 * The mobile accessibility button that leads to the accessibility settings screen
 * when clicked.
 *
 * @param onLandingPage - {@link AccessibilityButtonProps.onLandingPage onLandingPage} description.
 * @param dataTestId - {@link AccessibilityButtonProps.dataTestId dataTestId} description.
 */
const AccessibilityButton = ({
    onLandingPage,
    dataTestId,
}: AccessibilityButtonProps): ReactNode => {
    const Localization: LocalizationType = useLocalization();
    const navigate = useNavigate();

    return (
        <div data-testid={dataTestId} className={classNames(css.iconButton, onLandingPage ? css.onLandingPage : css.onNonLandingPage)}>
            <BaseButtonBase
                onClick={async () => navigate(AppRoutePaths.Accessibility)}
                title={Localization.ClickToOpenAccessibility}
                id={Localization.ClickToOpenAccessibility}
                ariaLabel={Localization.ClickToOpenAccessibility}
            >
                <GMSizedIcon iconType={'Accessibility'} iconSize={'custom'} />
            </BaseButtonBase>
        </div>
    );
};

export default AccessibilityButton;
